import AnimatedPage from './AnimatedPage';

/*
    Animation de la page Projets
*/
class Projets extends AnimatedPage{
    constructor(){
        super(200);

        this.filterMenu = $('.SiteHeader-filter');
        this.filterItem = $('.SiteHeader-filter a');
        this.activeFilter = $('.SiteHeader-filter a.isActive');

            // Affichage de la page
            this.showPage();
            // Initialisation du scroll
            this._initScroll();

            this._opacityCover();
            /* Filtre */
            this._filterMenu();
            this._filterSMMenu();


    }

    showPage(){
        let $h1 = $('.Cover h1'),
            $accroche = $('.Cover-filter'),
            $firstVisuel = $('.Cover-img')
        ;

        let tl = new TimelineLite()
        .fromTo($firstVisuel,1,{scale:1,autoAlpha:0},{scale:1.3,autoAlpha:1,ease:Power4.easeOut})
        .fromTo($h1, 0.7, {y:60, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power4.easeInOut},0)
        .fromTo($accroche,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.5)
        .add(this.showHeader(),.55)
    }

    _getAnimatedElements(){
        return [
            {$el:$('.projetResume'), fn:this._showProjetResume}
        ];
    }

    _showProjetResume(el){
        const tl = new TimelineLite()
        ;

        tl.fromTo(el,.7,{y:100,alpha:0},{y:0,alpha:1,force3D:true,ease:Power4.easeOut})
    }

    _filterMenu(){
        const line = $('.line',this.filterMenu),
            refthis = this
        ;

            let pos = this.activeFilter.position().left,
                marge = parseInt(this.activeFilter.css('margin-left')),
                w = this.activeFilter.width()
            ;

            $(window).resize(function(){
                pos = refthis.activeFilter.position().left;
                marge = parseInt(refthis.activeFilter.css('margin-left'));
                w = refthis.activeFilter.width();
                TweenLite.set(line,{x:pos+marge,width:w});
            }).trigger('resize');

            this.filterMenu.mouseleave(function(){
                TweenLite.to(line,0.5,{x:pos+marge,width:w,ease:Power4.easeOut})
            })


        this.filterItem.mouseenter(function(){
            let pos = $(this).position().left,
                marge = parseInt($(this).css('margin-left')),
                w = $(this).width()
            ;
            TweenLite.to(line,0.5,{x:pos+marge,width:w,ease:Power4.easeOut})
        });




    }

    _opacityCover(){
          var scroll = $(window).scrollTop(),
              targetScroll = 0,
              currentScroll = 0,
              jparalax = $('.parallax'),
              jDocument = $(document),
              $coverImg = $('.Cover-img img'),
              $h = $coverImg.height(),
              $this = this
          ;

          let 	opacityMin = 0,
                opacityMax = $coverImg.attr('data-opacity')/100,
                scrollMin = 0,
                scrollMax = $(window).height(),
                scrollRatio,
                opacityRatio,
                percent
         ;


          // parallax //
          $(window).scroll(function(e) {
              scroll = $(window).scrollTop();
              scrollRatio = scroll/scrollMax,
              opacityRatio = opacityMax - (opacityMax/(opacityMax - opacityMin) * scrollRatio);

                if(opacityRatio < opacityMin){
                    opacityRatio = opacityMin;
                }else if(opacityRatio > 1){
                    opacityRatio = opacityMax;
                }
                percent = scrollRatio*100;
                // $('.Cover-img img').css({'filter':`grayscale(${percent*2}%)`});

                $coverImg.css({
                    'opacity': opacityRatio,
                    'filter':`grayscale(${percent*2}%)`
                });
          });

      }

      _filterSMMenu(){
          const me = this,
             $filter = $('.filter'),
             $filterItem = $('.filter-item',$filter),
             $filterTitle = $('.filter-title',$filter)
       ;

       $filterTitle.click(function(){
           $filter.toggleClass('isOpen');

           return false;
       });

       $filterItem.click(function(){
           var term = $(this).attr('data-term'),
               text = $(this).text()
           ;

           // Affichage de l'item "projets recents"
           $filterItem.removeClass('hide');
           // Changement du titre du filtre
           $filterTitle.text(text);
           // On ferme le filtre
           $filter.removeClass('isOpen');


       });
      }
      _resize(){
          const refthis = this;
          $(window).resize(function(){
              refthis._filterMenu();
          });
      }
}
export default Projets;
